{
  "network": "No connection to the server. Check your internet.",
  "server_500": "Something went wrong on the server. Try again in a moment.",
  "forbidden": "You don't have permission for that.",
  "not_found": "Resource not found.",
  "validation": "Invalid data.",
  "rate_limit": "Too many requests. Wait a moment.",
  "generic": "We couldn't complete the action.",
  "boundary_title": "Something went wrong",
  "boundary_message": "This section ran into an unexpected error. You can reload the page or go back home.",
  "boundary_reload": "Reload page",
  "boundary_home": "Go home",
  "global_handler": "Something didn't work right. If it persists, reload the page.",
  "google_sign_in_browser_only": "Google Sign-In requires a browser.",
  "google_sign_in_load_failed": "Couldn't load Google Sign-In.",
  "google_client_id_missing": "VITE_GOOGLE_CLIENT_ID is not configured.",
  "google_no_credential": "Google didn't return a credential.",
  "not_found_page": {
    "title": "Page not found",
    "body": "The page you're looking for doesn't exist or has moved.",
    "home": "Go home",
    "app": "Go to my account"
  }
}
